import { HttpClient } from "@/App/services/HttpClient";
import { ENDPOINTS } from "@/TeamSelection/config";
import { handleHttpRequest } from "@/Case/services/handleHttpRequest";
import { Storage } from "@/App/services/LocalStorage";
import { EMSAgency } from "@/types/EMSAgency";

export const TeamSelectionService = {
  getComplaintSet(complaintSet: string): Promise<any> {
    return handleHttpRequest(HttpClient.get(ENDPOINTS.COMPLAINTSET(complaintSet)));
  },

  getTeam(id: string): Promise<any> {
    return handleHttpRequest(HttpClient.get(ENDPOINTS.TEAM(id)));
  },

  getHospitalStatuses(id: string): Promise<any> {
    return handleHttpRequest(HttpClient.get(ENDPOINTS.HOSPITAL_STATUSES(id)));
  },

  getStoredTeam(): EMSAgency {
    return JSON.parse(Storage.getItem("selectedTeam") || "null");
  },
};
